import { render, staticRenderFns } from "./accountInfo.vue?vue&type=template&id=46505772&scoped=true&"
import script from "./accountInfo.vue?vue&type=script&lang=js&"
export * from "./accountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46505772",
  null
  
)

export default component.exports